"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoPanel;
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _helpers = require("../../utils/helpers");
var _settings = require("../../settings");
var _InfoPanelModule = _interopRequireDefault(require("./../../scss/layout-wrappers/InfoPanel.module.scss"));
function InfoPanel(_ref) {
  let {
    layoutComponent = {
      layout: "",
      props: {}
    },
    onBackClicked = () => {},
    backButtonLabel = "Back to List",
    classname = ''
  } = _ref;
  const [Layout, setLayout] = (0, _react.useState)(null);
  const [state, setState] = (0, _react.useState)('entering');
  const panelRef = (0, _react.useRef)(null);
  const eventRef = (0, _react.useRef)(null);
  const handleBackBtnClicked = e => {
    eventRef.current = e;
    setState('exiting');
    panelRef.current.scrollTo({
      top: panelRef.current.offsetTop,
      left: 0,
      behaviour: 'instant'
    });
  };
  (0, _react.useEffect)(() => {
    // load the layout component used for this panel
    async function loadLayout() {
      setLayout(_settings.blockLayoutsMap.get(layoutComponent.layout));
    }
    loadLayout();
  }, [layoutComponent.layout]);
  (0, _react.useEffect)(() => {
    if (panelRef.current !== null) {
      if (state === 'exiting') {
        panelRef.current.addEventListener('animationend', () => {
          onBackClicked(eventRef.current);
        }, {
          once: true
        });
      }
      if (state === 'entering') {
        panelRef.current.addEventListener('animationend', () => {
          setState('idle');
        }, {
          once: true
        });
      }
    }
  }, [state, onBackClicked]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_InfoPanelModule.default['info-panel'], "".concat(classname)]),
    "data-state": state,
    ref: panelRef
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _helpers.classes)([_InfoPanelModule.default['info-panel__back-btn'], 'info-panel__back-btn']),
    type: "button",
    onClick: handleBackBtnClicked
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, null), backButtonLabel), Layout !== null && /*#__PURE__*/_react.default.createElement(Layout, layoutComponent.props), /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _helpers.classes)([_InfoPanelModule.default['info-panel__back-btn'], 'info-panel__back-btn']),
    type: "button",
    onClick: handleBackBtnClicked
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, null), backButtonLabel));
}